import React from "react";
import { PieChart, Tooltip, Pie, Cell, Sector } from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class PieChartStrategy extends ChartStrategy {
  render() {
    const {
      activeIndex,
      setActiveIndex,
      normalizedData,
      xAxis,
      yAxis,
      total,
      chartType,
    } = this.props;
    const showLabels = normalizedData.length <= 10;

    const activePie = (props) => {
      const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } =
        props;
      return (
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 10}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          cornerRadius={5}
        />
      );
    };

    return (
      <PieChart>
        <Tooltip content={<this.props.CustomTooltip />} />
        <Pie
          data={normalizedData}
          dataKey={yAxis}
          nameKey={xAxis}
          cx="50%"
          cy="50%"
          innerRadius={chartType === "donut" ? 60 : 0}
          outerRadius="80%"
          fill={DYCHARTCOLORS[0]}
          stroke="none"
          animationDuration={500}
          animationEasing="ease-out"
          activeIndex={activeIndex}
          activeShape={activePie}
          onMouseEnter={(_, index) => setActiveIndex(index)}
          labelLine={false}
          label={
            showLabels
              ? ({
                  cx,
                  cy,
                  midAngle,
                  innerRadius,
                  outerRadius,
                  index,
                  name,
                  value,
                }) => {
                  const RADIAN = Math.PI / 180;
                  const radius = innerRadius + (outerRadius - innerRadius) / 2;
                  const x = cx + radius * Math.cos(-midAngle * RADIAN);
                  const y = cy + radius * Math.sin(-midAngle * RADIAN);
                  const percent = ((value / total) * 100).toFixed(1);

                  return (
                    <text
                      x={x}
                      y={y}
                      fill="#fff"
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontSize={12}
                      fontWeight={600}
                    >
                      {`${name}: ${percent}%`}
                    </text>
                  );
                }
              : false
          }
        >
          {normalizedData.map((entry, index) => (
            <Cell
              key={index}
              fill={DYCHARTCOLORS[index % DYCHARTCOLORS.length]}
            />
          ))}
        </Pie>
      </PieChart>
    );
  }
}
